"use strict";

var _inherits = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Semaphore = /*#__PURE__*/function () {
  function Semaphore(count) {
    _classCallCheck(this, Semaphore);

    this.tasks = [];
    this.count = count;
  }

  _createClass(Semaphore, [{
    key: "sched",
    value: function sched() {
      if (this.count > 0 && this.tasks.length > 0) {
        this.count--;
        var next = this.tasks.shift();

        if (next === undefined) {
          throw "Unexpected undefined value in tasks list";
        }

        next();
      }
    }
  }, {
    key: "acquire",
    value: function acquire() {
      var _this = this;

      return new Promise(function (res, rej) {
        var task = function task() {
          var released = false;
          res(function () {
            if (!released) {
              released = true;
              _this.count++;

              _this.sched();
            }
          });
        };

        _this.tasks.push(task);

        if (process && process.nextTick) {
          process.nextTick(_this.sched.bind(_this));
        } else {
          setImmediate(_this.sched.bind(_this));
        }
      });
    }
  }, {
    key: "use",
    value: function use(f) {
      return this.acquire().then(function (release) {
        return f().then(function (res) {
          release();
          return res;
        }).catch(function (err) {
          release();
          throw err;
        });
      });
    }
  }]);

  return Semaphore;
}();

exports.Semaphore = Semaphore;

var Mutex = /*#__PURE__*/function (_Semaphore) {
  _inherits(Mutex, _Semaphore);

  var _super = _createSuper(Mutex);

  function Mutex() {
    _classCallCheck(this, Mutex);

    return _super.call(this, 1);
  }

  return Mutex;
}(Semaphore);

exports.Mutex = Mutex;